import React from 'react';
import { fmt } from '../kuroco/fmt';
import { asOfLabel, cardModel, formatDelta, sortForCompare, totalsModel } from '../../utils/storeView';

const yen = (v) => fmt('currency', v);

/** 増減の向きの class（▲ は緑・▼ は赤・同じ・比べる先なし）。 */
const dir = (d) => (d == null ? 'flat' : d > 0 ? 'up' : d < 0 ? 'down' : 'flat');

function Total({ totals, summary, title }) {
  const delta = formatDelta(totals.delta);
  const label = asOfLabel(summary.as_of);
  return (
    <section className="sv-total" aria-label={`${title}の合計`}>
      <div>
        <div className="sv-k">売上合計{label ? `（1日${label}）` : ''}</div>
        <div className="sv-v">{totals.sales ? yen(totals.sales) : '—'}</div>
        {delta && <div className={`sv-sc-d sv-delta--${dir(totals.delta)}`}>{delta} 先月同時期</div>}
      </div>
      <div>
        <div className="sv-k">目標達成率</div>
        <div className="sv-v">{totals.salesPct == null ? '—' : `${totals.salesPct}%`}</div>
      </div>
      <div>
        <div className="sv-k">客数</div>
        <div className="sv-v">{totals.customers ? fmt('count', totals.customers) : '—'}</div>
      </div>
    </section>
  );
}

function StoreCard({ card, onPick }) {
  const delta = formatDelta(card.delta);
  return (
    <button
      type="button"
      className={`sv-st${card.tone === 'warn' ? ' sv-st--alert' : ''}${card.isMine ? ' sv-st--mine' : ''}`}
      onClick={() => onPick?.(card.store)}
    >
      <div className="sv-st-h">
        <span className="sv-st-n">{card.store}</span>
        {card.isMine && <span className="sv-st-b">自店舗</span>}
      </div>
      <div className="sv-st-g">
        <div>
          <div className="sv-k">売上</div>
          <div className="sv-st-v">
            {card.sales == null ? '—' : yen(card.sales)}
            {delta && <span className={`sv-st-d sv-delta--${dir(card.delta)}`}>{delta}</span>}
          </div>
        </div>
        <div>
          <div className="sv-k">目標達成率</div>
          <div className={`sv-st-v sv-st-pct sv-st-pct--${card.tone}`}>{card.salesPct == null ? '—' : `${card.salesPct}%`}</div>
        </div>
        <div>
          <div className="sv-k">客単価</div>
          <div className="sv-st-v">{card.unitPrice == null ? '—' : yen(card.unitPrice)}</div>
        </div>
      </div>
      {card.chips && (
        <div className="sv-st-ppl">
          {card.chips.map((c) => (
            <span key={c.key} className={`sv-chip sv-chip--${c.key === 'unset' ? 'none' : c.key}`}>
              {c.label} {c.n}
            </span>
          ))}
        </div>
      )}
    </button>
  );
}

/**
 * 全店比較: 見えている店舗の合計 1 行 ＋ 店舗カード（達成率の低い順）。タップでその店舗の「この店舗」へ。
 * 店舗全体の数字はスタイリストにも見せる。人数チップは管理者だけ（buckets がある店舗のみ）。個人名は出ない。
 */
export default function StoreAllView({ summary, buckets, isAdmin, myStore, title, onPick }) {
  const { data, loading, error } = summary;
  if (loading && !data) return <div className="scope-empty">読み込み中…</div>;
  if (error) return <div className="scope-empty">店舗の数字を読み込めませんでした。もう一度お試しください</div>;
  const stores = data?.stores || [];
  if (stores.length === 0) return <div className="scope-empty">表示できる店舗がありません</div>;

  const bucketOf = (name) => buckets?.data?.stores?.find((s) => s.store === name) || null;
  const judged = buckets?.data?.judged ?? true;
  const sorted = sortForCompare(stores);
  return (
    <>
      <Total totals={totalsModel(stores)} summary={data} title={title} />
      <div className="sv-sort">
        <span>{stores.length}店舗</span>
        <span>
          並び: <b>達成率が低い順</b>
        </span>
      </div>
      {sorted.map((entry) => (
        <StoreCard
          key={entry.store}
          card={cardModel(entry, { isAdmin, bucketsEntry: bucketOf(entry.store), judged, myStore })}
          onPick={onPick}
        />
      ))}
    </>
  );
}
